<template>
  <component
    :is="triggerComponentName"
    :trigger="trigger"
    @validityUpdated="validityUpdated"
    :triggerIndex="triggerIndex"
    class="trigger-card"
    :class="{ dimmed: trigger.disabled }"
  >
    <div class="extra content" slot="footer">
      <span class="right floated">
        <div class="ui basic mini red icon button" v-on:click="deleteTrigger">
          <i class="trash icon"></i>
        </div>
      </span>
      <span>
        <div class="ui toggle checkbox">
          <input
            type="checkbox"
            class="hidden"
            :checked="!trigger.disabled"
            @change="setEnabled($event.currentTarget.checked)"
            :id="triggerIndex + '-' + triggerComponentName + '-enabled'"
          />
          <label :for="triggerIndex + '-' + triggerComponentName + '-enabled'">
            {{ $t('TRIGGER_ENABLED') }}
          </label>
        </div>
      </span>
    </div>
  </component>
</template>

<style lang="scss">
.trigger-card {
  &.dimmed {
    opacity: 0.4;
  }
}
</style>
<script>
// @flow
import KeyboardTrigger from './KeyboardTrigger'
import HotkeyTrigger from './HotkeyTrigger'
import EventInterceptTrigger from './EventInterceptTrigger'
import CronTrigger from './CronTrigger'
import WindowTrigger from './WindowTrigger'
import LifecycleTrigger from './LifecycleTrigger'
import ContextTrigger from './ContextTrigger'
import FileSystemTrigger from './FileSystemTrigger'
import MailServiceTrigger from './MailServiceTrigger'
import SerialPortServiceTrigger from './SerialPortServiceTrigger'
import MQServiceTrigger from './MQServiceTrigger'
import TableTrigger from './TableTrigger'
import ChatServiceTrigger from './ChatServiceTrigger'

export default {
  name: 'trigger',
  // NOTE: Map the components to the string we get by prepending this.componentNamePrefix lowercased to '-trigger'
  components: {
    CronTrigger,
    HotkeyTrigger,
    TableTrigger,
    'intercept-trigger': EventInterceptTrigger,
    'window_shown-trigger': WindowTrigger,
    'window_hidden-trigger': WindowTrigger,
    LifecycleTrigger,
    ContextTrigger,
    KeyboardTrigger,
    'filesystem-trigger': FileSystemTrigger,
    'mail-trigger': MailServiceTrigger,
    'serialport-trigger': SerialPortServiceTrigger,
    'mq-trigger': MQServiceTrigger,
    'chat-trigger': ChatServiceTrigger
  },
  props: {
    initTrigger: {
      type: Object
    },
    componentNamePrefix: {
      type: String,
      default: ''
    },
    triggerIndex: Number
  },
  computed: {
    triggerComponentName() {
      let prefix = this.componentNamePrefix.toLowerCase()
      return prefix + '-trigger'
    }
  },
  methods: {
    deleteTrigger() {
      this.$emit('delete')
    },
    validityUpdated(invalid) {
      this.$emit('validityUpdated', invalid)
    },
    setEnabled(enabled) {
      // The 'disabled' property may not be there - so make sure it's reactive from now on
      this.$set(this.trigger, 'disabled', !enabled)
    }
  },

  data() {
    return {
      trigger: _.cloneDeep(this.initTrigger)
    }
  },

  watch: {
    trigger: {
      handler: function() {
        if (!_.isEqual(this.trigger, this.initTrigger))
          this.$emit('change', _.cloneDeep(this.trigger))
      },
      deep: true
    },
    initTrigger: {
      handler: function() {
        this.trigger = _.cloneDeep(this.initTrigger)
      }
    }
  }
}
//
</script>
